// src/api/adminSupplierApi.ts
import { http } from "./http";

export const fetchSuppliers = async () => {
  const res = await http.get("/api/admin/suppliers");
  return res.data.suppliers;
};

export const createSupplier = async (payload: {
  name: string;
  email?: string;
  phone?: string;
  address?: string;
}) => {
  const res = await http.post("/api/admin/suppliers", payload);
  return res.data;
};

export const updateSupplier = async (
  id: number,
  payload: {
    name?: string;
    email?: string;
    phone?: string;
    address?: string;
  }
) => {
  const res = await http.put(`/api/admin/suppliers/${id}`, payload);
  return res.data;
};

export const deleteSupplier = async (id: number) => {
  const res = await http.delete(`/api/admin/suppliers/${id}`);
  return res.data;
};

export const searchSuppliers = async (query: string) => {
  const res = await http.get("/api/admin/suppliers/search", {
    params: { query },
  });
  return res.data.suppliers; // [{ id, name }]
};

export const getProductSuppliers = async (productId: number) => {
  const res = await http.get(`/api/admin/suppliers/by-product/${productId}`);
  return res.data.suppliers;
};

export const assignSuppliersToProduct = async (payload: {
  product_id: number;
  supplier_ids: number[];
  primary_supplier_id: number | null;
}) => {
  const res = await http.patch("/api/admin/suppliers/assign", payload);
  return res.data;
};

export const getAllProductsWithSuppliers = async () => {
  const res = await http.get("/api/admin/suppliers/products-with-suppliers");
  return res.data.products;
};